import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

class Input extends Component {
  render() {
    return <Root {...this.props} />;
  }
}

const Root = styled.input`
  width: 100%;
  max-width: ${props => props.short && '153px'};
  padding: 14px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #fff;
  color: #fff;
  font-family: 'DINOT';
  font-size: 18px;
  outline: none;
  transition: all 0.25s max-width 0;
  box-shadow: 0 0 5px 0 transparent;
  &:focus {
    box-shadow: 0 0 5px 0 #f58320;
    border: 1px solid #f58320;
  }
  &:-webkit-autofill {
    -webkit-text-fill-color: #fff;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }
  @media (max-width: ${media.xs}) {
    max-width: 100%;
  }
  /* For Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
  /* Webkit browsers like Safari and Chrome */
  &[type=number]::-webkit-inner-spin-button,
  &[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default Input;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Input.js